module.exports = __webpack_public_path__ + "static/media/JD-Advising_logo-Tall.09bd8ccc.png";